export const version: string = '1.2.1';
// todo: retrieve this from package.json
